/*
 * @Author: 晾衣架 1308251352@qq.com
 * @Date: 2023-07-25 09:12:38
 * @LastEditors: 晾衣架 1308251352@qq.com
 * @LastEditTime: 2023-08-02 13:33:36
 * @FilePath: /m-terminal-PC/src/router/routes/modules/member.ts
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import type { AppRouteModule } from '/@/router/types';

import { LAYOUT2 } from '/@/router/constant';
import { t, useLocale } from '@mcex/locale';

import { PageEnum } from '/@/enums/pageEnum';
import { MenuCodeEnum } from '/@/enums/menuCodeEnum';
//import { useRegisterFormStore } from '/@/store/modules/registerForm';
import { MEMBER_DOMAIN_MAP } from '/@/api/const';
import { useUserStoreWithOut } from '/@/store/modules/user';
import { unref } from 'vue';

const { getLocale } = useLocale();

const IFrame = () => import('/@/views/sys/iframe/index.vue');
// 会员
const member: AppRouteModule[] = [
  {
    path: '/member',
    name: 'Member',
    component: LAYOUT2,
    redirect: PageEnum.MEMBER_ROLES,
    meta: {
      orderNo: 3,
      icon: 'menus-management|svg',
      title: t('routes.member.management'),
      menuCodes: [MenuCodeEnum.userMgr],
      isChildrenPopover: true,
    },
    children: [
      {
        path: 'account_management/:type?',
        props: true,
        name: 'TransactionAccount',
        component: () => import('/@/views/exchangeService/member/account_management/index.vue'),
        meta: {
          title: t('routes.member.accountManagement'),
          // TODO: 后端改好权限后需要修改
          menuCodes: [MenuCodeEnum.userMgrAccMgr],
        },
        beforeEnter: (to, _from, next) => {
          const type = to.params.type;
          // type 为 :type时 修复地址移除:type
          if (type === ':type') {
            next({ path: PageEnum.MEMBER_ACCOUNT_MANAGEMENT });
          } else {
            next();
          }
        },
      },
      {
        path: 'roles',
        name: 'MemberRoles',
        component: () => import('/@/views/exchangeService/member/roles/index.vue'),
        meta: {
          title: t('routes.member.userManagement'),
          menuCodes: [MenuCodeEnum.userMgrUser],
        },
      },
      {
        path: 'memberInfo',
        name: 'MemberInfo',
        component: IFrame,
        meta: {
          title: t('routes.member.memberInfo'),
          menuCodes: [MenuCodeEnum.userMgrInfo],
          frameSrc: () => {
            const token = unref(useUserStoreWithOut().getToken);
            const refreshToken = unref(useUserStoreWithOut().getRefreshToken);
            const { host, protocol, pathname } = window.location;
            const memberUrl = `${protocol}//${
              MEMBER_DOMAIN_MAP[host].homeDigit
            }${pathname}?frame=true&token=${encodeURIComponent(token)}&rt=${encodeURIComponent(
              refreshToken,
            )}&lang=${unref(getLocale)}&redirect=${PageEnum.MEMBER_INFO_VIEW}`;
            return memberUrl;
          },
        },
      },
      {
        path: 'updateMemberInfo',
        name: 'UpdateMemberInfo',
        component: IFrame,
        meta: {
          title: t('routes.member.modification'),
          menuCodes: [MenuCodeEnum.userMgrInfoModification],
          frameSrc: () => {
            const token = unref(useUserStoreWithOut().getToken);
            const refreshToken = unref(useUserStoreWithOut().getRefreshToken);
            const { host, protocol, pathname } = window.location;
            const memberUrl = `${protocol}//${
              MEMBER_DOMAIN_MAP[host].homeDigit
            }${pathname}?frame=true&token=${encodeURIComponent(token)}&rt=${encodeURIComponent(
              refreshToken,
            )}&lang=${unref(getLocale)}&redirect=${PageEnum.UPDATE_MEMBER_INFO}`;
            return memberUrl;
          },
        },
      },
    ],
  },
  {
    path: '/user',
    name: 'User',
    component: LAYOUT2,
    redirect: PageEnum.USER_INFO,
    meta: {
      orderNo: 3,
      icon: 'menus-member|svg',
      title: t('routes.mcex.member'),
      hideMenu: true,
      hideBreadcrumb: true,
      menuCodes: [MenuCodeEnum.userInfo],
    },
    children: [
      {
        path: 'index',
        name: 'UserIndex',
        component: () => import('/@/views/exchangeService/user/index.vue'),
        meta: {
          title: t('用户信息'),
          hideMenu: true,
        },
      },
    ],
  },
];

export default member;
